import {
  school,
  detail1,
  detail2,
  detail3,
  detail4,
  detail5,
  domain,
  placeholder,
  country,
  opportunity,
  opportunityImage,
  slider4,
  cardImages
} from "../assets/images";

// LANGUES
export const LANGUES = [
  { value: 510, label: "Anglais" },
  { value: 511, label: "Français" },
  { value: 512, label: "Allemand" },
  { value: 513, label: "Espagnol" },
  { value: 514, label: "Turque" },
  { value: 515, label: "Yoruba" },
  { value: 516, label: "Wolof" },
  { value: 517, label: "Madarin" },
  { value: 518, label: "Russe" },
  { value: 519, label: "Japonais" },
  { value: 520, label: "Arabe" },
];

export const INSTITUTE_CITY = [
  { value: 1, label: "Nairobi" },
  { value: 2, label: "Cape Town" },
  { value: 3, label: "Cairo" },
  { value: 4, label: "Addis Ababa" },
  { value: 5, label: "Luanda" },
];

export const STUDIES_LEVELS = [
  { value: 997, label: "BTS, DUT, Licence" },
  { value: 998, label: "Master" },
  { value: 999, label: "Doctorat et diplômes professionnels" },
];

export const GRADE = [
  { id: "1", grade: "A" },
  { id: "2", grade: "A+" },
  { id: "3", grade: "B" },
  { id: "4", grade: "B+" },
  { id: "5", grade: "C" },
  { id: "6", grade: "C+" },
  { id: "7", grade: "D" },
  { id: "8", grade: "D+" },
];
export const GRADE_SCALE = [
  { id: "1", grade: "KG" },
  { id: "2", grade: "DZ" },
  { id: "3", grade: "LTR" },
  { id: "4", grade: "CM" },
  { id: "5", grade: "MTR" },
];

// DIPLOMES
export const DIPLOMES = [
  { value: 377, label: "Autres formations non-diplômantes" },
  { value: 370, label: "Licence Pro. (Bac +1 à 3)" },
  { value: 368, label: "DUT" },
  { value: 369, label: "Doctorat" },
  { value: 371, label: "Bachelor (Bac +4)" },
  { value: 373, label: "Master 2 Pro. (Bac +5)" },
];

// SECTORS
export const SECTORS = [
  { value: 350, label: "Aérien, aéroportuaire & aéronautique" },
  {
    value: 382,
    label: "Agriculture, sylviculture, halieutique & sciences vétérinaires",
  },
  { value: 399, label: "Architecture et urbanisme" },
  { value: 349, label: "Commerce & administration" },
  { value: 348, label: "Défense, paix & sécurité" },
  { value: 391, label: "Diagnostic médical et technologie de traitement" },
  { value: 347, label: "Droit" },
  { value: 346, label: "Éducation" },
  { value: 342, label: "Environnement et environnement durable" },
  {
    value: 341,
    label: "Ingénierie, industries de transformation & construction",
  },
  { value: 340, label: "Lettres et arts" },
  {
    value: 395,
    label: "Médecine et thérapies traditionnelles et complémentaires",
  },
  { value: 392, label: "Pharmacie" },
  {
    value: 334,
    label:
      "Programmes internationaux (pathways & communautaires), certifications génériques",
  },
  { value: 339, label: "Santé & protection sociale" },
  { value: 338, label: "Sciences naturelles, mathématiques et statistiques" },
  { value: 337, label: "Sciences sociales, journalisme & information" },
  { value: 397, label: "Soins aux enfants et à la jeunesse" },
  { value: 396, label: "Soins gérontologiques et aux adultes handicapés" },
  { value: 390, label: "Soins infirmiers et formation de sages-femmes" },
  { value: 336, label: "Technologies de l’information et de la communication" },
  { value: 394, label: "Thérapie et rééducation" },
  { value: 335, label: "Tourisme, hôtellerie & services de restauration" },
  { value: 398, label: "Travail social et orientation" },
];

// FAQS
export const FAQS = [
  {
    question:
      "Pouvez-vous m’envoyer des informations sur votre établissement (X) ? (brochure)",
  },
  { question: "Quelle est la date de la prochaine rentrée ?" },
  {
    question:
      "L’établissement (X) offre-t-il des bourses aux étudiants du 1er cycle ?",
  },
  {
    question:
      "L’établissement (X) offre-t-il des bourses aux étudiants des cycles supérieurs ?",
  },
  { question: "Quelles sont les modalités  de paiement disponibles ?" },
  {
    question:
      "Il y a t'il une résidence ou des logements universitaires près de l’établissement (X) ?",
  },
  {
    question:
      "L’établissement (X) a-t-il un service d’accueil des étudiants étranger ?",
  },
  { question: "Autres" },
];

// TEXTES
const TEXTES = {
  top10: "",
  presentation:
    "<p>Situé en Afrique de l’Ouest, le Bénin couvre une superficie de 114 763 Km2 et partage ses frontières avec le Niger, le Burkina-Faso, le Togo et le Nigéria. En 2019, la population béninoise est estimée à 11 857 627 d’habitants. La langue officielle du pays est le Français et les langues nationales principales sont le fon, le yoruba, le bariba, le dendi, le goun, l’adja et l’ayizo.</p><p>Le Bénin est membre de la Communauté Economique des Etats de l’Afrique de l’Ouest (CEDEAO) et utilise le franc CFA (XOF) comme monnaie (1 EUR = 656 XOF, 1 USD = 530 XOF environ. Attention les taux de change fluctuent régulièrement).</p><p>Bien que les religions traditionnelles occupent toujours une place de choix dans les croyances béninoises, le Bénin est un pays laïque à dominances chrétienne (54%) et musulmane (24%). La capitale administrative du Bénin est Porto-Novo et les grandes villes où sont implantées les grandes universités sont : Cotonou, Parakou et Abomey-Calavi.</p>",
  enseignement:
    "<p>Le système éducatif béninois, calqué sur le système francophone d’enseignement, est piloté par les ministères sectoriels chargés de l’Éducation.  L’enseignement supérieur au Bénin est placé sous la tutelle du ministère béninois de l’enseignement supérieur et de la Recherche scientifique (ici).</p><p>Le Bénin dispose de quatre (04) grandes universités, d’instituts universitaires d’enseignement professionnels, d’écoles inter-Etats et de près d’une soixantaine d’établissements privés d’enseignement supérieur reconnus par l’état. L’enseignement supérieur est organisé en trois cycles et est coordonné par la Direction Générale de l’Enseignement Supérieur (DGES) qui est un organe technique du Ministère de l’Enseignement Supérieur.</p><p>Selon les écoles et les choix des candidats, l’admission est faite après étude de dossier et/ou concours. Les procédures d’inscription dans les établissements relèvent de l’autorité des différents établissements et varient d’un établissement à un autre.</p><p>Les procédures d’inscription pour les étudiants béninois ayant obtenu des bacs étrangers et pour les étudiants étrangers désirant poursuivre leurs études universitaires au Bénin peuvent différer de celles des étudiants locaux. Un dossier doit être soumis à cet effet à la Commission Universitaire d’Orientation pour étude avant l’inscription. L’année universitaire débutant généralement en Octobre, il faudra s’y prendre tôt pour les démarches en se rapprochant des services académiques de l’université ou de l’école choisie.</p><p>Les frais d’études pour une année universitaire (frais d’inscription inclus) dans les établissements publics varient selon l’institution, la filière, le cycle et le régime d’étude. Pour les étudiants nationaux, ils varient entre 150 000 F CFA et 500 000 F CFA. Les étudiants étrangers doivent prévoir entre 210 000 F CFA et 1 500 000 F CFA selon leurs choix et leur zone de provenance (Zone UEMOA, Zone CEDEAO, autres nationalités). Ces frais peuvent être plus élevés au niveau de certains établissements privés. Ces coûts ne prennent pas en compte les autres dépenses liées aux logements, déplacements, restauration, etc.</p>",
  vie: "<p>Le coût de la vie est relativement abordable comparativement à d’autres pays d’Afrique francophone. Cotonou, la capitale économique du Bénin selon le classement Mercer 2020 des villes les plus chères occupe la 21ème place africaine.</p><p><strong>Ressources pour trouver un logement étudiant</strong></p><p>Les logements universitaires sont attribués par les Centres des Œuvres Universitaires et Secours (COUS) des universités concernées. Les conditions d’attribution des logements diffèrent selon les universités et les logements sont généralement attribués après le démarrage des activités académiques. Ce sont ces mêmes centres qui s’occupent du transport des étudiants ainsi que de la restauration sur les différents sites.</p><p>En dehors des logements étudiants accessibles sur les centres universitaires, les étudiants ont la possibilité de louer des appartements dans la ville. Au niveau des logements privés, les coûts sont relativement plus élevés. Pour disposer d’un cadre adéquat, il faudra généralement débourser entre  25 000 FCFA et 100.000 FCFA pour les loyers mensuels et compter en complément en moyenne  100 000 F CFA pour les différentes démarches de location (trois mois de caution pour le loyer, la caution pour le courant et l’eau et prévoir une commission si l’on fait recours à des agents immobiliers pouvant atteindre les 50% du premier loyer mensuel).</p><p><strong>Un étudiant étranger  devrait prévoir au minimum 150 000 FCFA/mois pour ses frais de vie</strong></p><p><ul><li>Loyer : 50.000 F CFA/mois</li><li>Restauration : 1 000 FCFA/jour</li><li>Déplacements par taxi-moto ou taxi (1 000 FCFA/jour, un trajet du centre ville vers l’université d’Abomey-Calavi coûte 500 FCFA)</li><li>Loisirs : 20 000 FCFA (Salle de cinéma 5 000 FCFA, Restaurant 10 000 FCFA …)</li></ul></p>",
  sejour:
    "<p><strong>Conditions d’entrée sur le territoire</strong></p><p>Le Bénin signé des accords avec certains pays tant africains que situés hors de l’Afrique pour l’exemption réciproque du visa d’entrée sur leurs territoires</p><p>Les ressortissants des 15 pays membres de la CEDEAO et des 08 membres de l’UEMOA peuvent entrer sur le territoire béninois et y résider pendant une durée de trois mois (90 jours). Les étudiants peuvent immigrer sur le territoire et mener ensuite les démarches pour régulariser leurs situations. Ils peuvent également obtenir leurs visas auprès des représentations diplomatiques du Bénin au niveau de leurs pays de résidence. Les étudiants des autres régions de l’Afrique bénéficient également de cette exemption de visa pour l’entrée sur le territoire pour une période de 90 jours. La liste des représentations diplomatiques du Bénin ici.</p><p>L’entrée sur le territoire béninois est subordonnée au respect des conditions sanitaires (vaccins contre les hépatites, la méningite, la rage,… et le test COVID-19,…).</p><p><strong>Conditions de séjour et de travail étudiants/visa y compris institutions clés pour démarches</strong></p><p>Les conditions de séjour et d’obtention des visas longs séjours sont consultables sur le site de la Direction de l’Emigration et de l’Immigration (DEI). Il s’agit notamment des conditions liées à la  résidence, la moralité du demandeur, de l’exercice ou non d’un emploi,… Les étudiants étrangers vivant au Bénin qui remplissent les conditions de recrutement (critères spécifiques des différentes offres) et qui le désirent peuvent travailler.</p>",
  description:
    "<p>L’EAMAU, basée à Lomé au Togo est une institution inter-états d’enseignement supérieur et de recherche fondée en 1975. L&#8217;école offre des formation en architecture et urbanisme au bénéfice des Etats africains. À ce jour, le service de l’EAMAU s’étend sur 14 pays d’Afrique francophone. L&#8217;accès aux formations initiales de l&#8217;EAMAU se fait principalement par concours. L&#8217;école offre les formations initiales suivantes:</p> <p>&#8211; Architecture(licence et master)</p> <p>&#8211; Urbanisme(licence et master)</p><ul><li>&#8211; Gestion urbaine (licence et master)</li><li>&#8211; Master Transport (débuté à partir de la rentrée académique 2015-2016)</li><li>&#8211; Master Recherche Architecture et Développement Urbain</li></ul>",
  domain:
    "<p><span>Vous avez une passion pour la production animale ou végétale ? Vous êtes peut-être fait pour vous lancer dans ce secteur qui génère de nombreux emplois dans les activités de production, de conseil et de commercialisation. Il rassemble les activités suivantes:</span></p><ul><li><span>L&#8217;agriculture qui englobe les cultures végétales et la production animale afin de produire les ressources  et animales indispensables </span></li><li><span>La sylviculture: le développement des forêts ou boisement pour en tirer un intérêt économique</span></li><li><span>L&#8217;halieutique qui est la science <em>de</em> l&#8217;exploitation des ressources vivantes aquatiques et englobe tous les savoir-faire qui se rapportent à aux métiers de la pêche, aquaculture, et les services annexes</span></li><li><span>Les sciences vétérinaires,  le domaine de la santé qui se penche sur le diagnostic et le traitement des animaux</span></li></ul><p><span>A l&#8217;exception des sciences vétérinaires qui impliquent de longues études, la majorité des métiers de ce secteur sont accessibles après 2 à 3 ans d&#8217;études.  </span></p><p><span><b>Pour se lancer dans ce secteur, il est souvent nécessaire: </b></span></p><ul><li><span>d&#8217;avoir un amour pour les animaux</span></li><li><span><span>d&#8217;ê</span><span>tre une excellent forme physique et endurant</span></span></li><li><span>d&#8217;<span>aimer les travaux manuels</span></span></li><li><span>d&#8217;aimer vivre en milieu rural </span></li></ul><p>&nbsp;</p>",
};

// DETAILS
const DETAILS = [
  { image: detail1, alt: "detail 1" },
  { image: detail2, alt: "detail 2" },
  { image: detail3, alt: "detail 3" },
  { image: detail4, alt: "detail 4" },
  { image: detail5, alt: "detail 5" },
];

// COUNTRIES
export const COUNTRY = {
  countryCode: "bj",
  publicId: "bGDvuwYFEH",
  name: "Bénin",
  city: "Cotonou",
  address: "Rue Doumasséssé",
  image: country,
  sliders: DETAILS,
};

// SCHOOLS
export const SCHOOL = {
  image: school,
  sliders: DETAILS,
  description: TEXTES.description,
};

// FOREIGNS
export const FOREIGNS = [
  { code: "bj", name: "Bénin" },
  { code: "ML", name: "Mali" },
  { code: "CI", name: "Côte d’Ivoire" },
  { code: "CM", name: "Cameroon" },
  { code: "ET", name: "Ethiopie" },
  { code: "GA", name: "Gabon" },
  { code: "NG", name: "Nigéria" },
];

// DOMAINS
export const DOMAIN = {
  image: placeholder,
  sliders: DETAILS,
  content: TEXTES.domain,
  tag: "Agriculture",
  icon: domain,
};

// OPPORTUNITIES
export const OPPORTUNITY = {
  image: opportunityImage,
  // coordinates: { lat: 28.207609, lng: 79.82666 },
  coordinates: { lat: 46.181670, lng: 6.122346 },
  officialLink: "https://www.wascal-ci.org/?q=appel-2021",
  medias: DETAILS,
};

export const ARTICLE_BANNER = {
  image: cardImages,
  // coordinates: { lat: 28.207609, lng: 79.82666 },
  // officialLink: "https://www.wascal-ci.org/?q=appel-2021",
  // medias: DETAILS,
};

// USER
export const USER = {
  id: 1,
  name: "Archile John",
  email: "john@example.com",
  phone: null,
  description: null,
  publicId: "g2hEdPmJ5y",
  profile: "parent",
  schoolId: null,
  countryId: null,
};

// TESTIMONY
export const TESTIMONY = {
  words: {
    author: "Feugiat Rhoncus",
    authorLevel: "1er Cycle",
    content:
      "Faucibus nisl tincidunt eget nullam non. Dictum sit amet justo donec enim diam vulputate ut. Sed turpis tincidunt id aliquet risus feugiat in ante.",
  },
  video: { videoLink: slider4 },
};

// CATEGORIES LIST
export const CATEGORIES = [
  { value: 1, label: "Autres" },
  { value: 352, label: "Bourses complètes" },
  { value: 412, label: "Conseils & Ressources" },
  { value: 209, label: "Post-doctoral" },
  { value: 355, label: "Stage non rémunérés" },
];

export const OPP_CATEGORIES = [
  { value: "Bourses complètes", label: "Bourses complètes" },
  {
    value: "Bourses scolarité complètes",
    label: "Bourses scolarité complètes",
  },
  { value: "Bourses partielles", label: "Bourses partielles" },
  { value: "Fellowship", label: "Fellowship" },
  { value: "Stages rémunérés", label: "Stages rémunérés" },
  { value: "Stages non rémunérés", label: "Stages non rémunérés " },
  { value: "Programmes jeunes diplômés", label: "Programmes jeunes diplômés" },
  { value: "Post-doctorats", label: "Post-doctorats" },
  { value: "Concours d’admission", label: "Concours d’admission" },
  {
    value: "Compétitions (y compris Entreprenariat)",
    label: "Compétitions (y compris Entreprenariat)",
  },
];

// LOCATIONS LIST
export const COUNTRIES = [
  { value: 308, label: "Afrique du Sud" },
  { value: 310, label: "Canada" },
  { value: 312, label: "Côte d'Ivoire" },
  { value: 309, label: "Ghana" },
  { value: 303, label: "Indie" },
  { value: 305, label: "Népal" },
  { value: 313, label: "Cameroun" },
  { value: 10, label: "Tchad" },
  { value: 1, label: "Zambie" },
  { value: 2, label: "République Centrafricaine" },
  { value: 3, label: "Guinée Équatoriale" },
  { value: 4, label: "Australie" },
  { value: 5, label: "Jordanie" },
  { value: 6, label: "Madagascar" },
  { value: 7, label: "Sénégal" },
  { value: 8, label: "Égypte" },
  { value: 9, label: "Bénin" },
];

export const LOCATIONS = [
  ...[
    { value: 364, label: "Monde" },
    { value: 367, label: "Afrique" },
    { value: 369, label: "Europe" },
    { value: 380, label: "Asie" },
    { value: 381, label: "Amérique" },
  ],
  ...COUNTRIES,
];

export const NATIONALITIES = [
  ...[
    { value: 364, label: "Monde" },
    { value: 367, label: "Afrique" },
    { value: 383, label: "Afrique subsaharienne" },
  ],
  ...COUNTRIES,
];

// LEVELS LIST
export const LEVELS = [
  { value: 357, label: "Collège & Lycée" },
  { value: 304, label: "Baccalauréat" },
  { value: 306, label: "Licence (BAC +3)" },
  { value: 311, label: "Master 1 ou 2 (BAC +4 ou +5)" },
  { value: 359, label: "Doctorat" },
];

// DUE DATES LIST
export const DUE_DATES = [
  { value: "justClosed", label: "Recemment fermé" },
  { value: "-15days", label: "Moins de 15 jours" },
  { value: "-30days", label: "Moins de 30 jours" },
  { value: "continuous", label: "En continue" },
];

// REMAINING TIME LIST
export const REMAINING_TIME = [
  { value: "justClosed", label: "Recemment fermé" },
  { value: "-7days", label: "Moins de 7 jours" },
  { value: "-15days", label: "Moins de 15 jours" },
  { value: "-30days", label: "Moins de 30 jours" },
  { value: "-60days", label: "Moins de 60 jours" },
];

// FORMATIONS DURATIONS
export const FORMATIONS_DURATIONS = [
  { value: "6 mois", label: "6 mois" },
  { value: "12 mois", label: "12 mois" },
  { value: "3 ans", label: "3 ans" },
  { value: "5 ans", label: "5 ans" },
];

// ARTICLES FILTERS
export const ARTICLES_FILTERS = [
  { value: "all", label: "Tous" },
  { value: "news", label: "Actualités" },
  { value: "tips", label: "Conseils" },
  { value: "stories", label: "Témoignages" },
];
